import { P } from "apparatus/library/common";
import { Color, Gradient, Group, Rectangle, Shape } from "paper";
import { setDefaultStyle } from "../draw";
export class Table {
    constructor() {
        this.drivers = [
            {
                type: "rectangle",
                minX: 400, maxX: 1500,
                minY: 0, maxY: 20,
                fromAppearance: a => P(a.width, 20),
                toAppearance: (f, p) => f({ width: p.x }),
                scale: 2.0,
            }
        ];
    }
    render(appearance) {
        let { width, thickness } = appearance;
        let corner = thickness / 4;
        let legOffset = appearance.legOffset;
        let legHeight = getLegHeight(appearance);
        let tableTopRect = new Rectangle(0, 0, width, thickness);
        let leftLegRect = new Rectangle(legOffset, corner, thickness, legHeight);
        let rightLegRect = new Rectangle(width - thickness - legOffset, corner, thickness, legHeight);
        let tableTop = Shape.Rectangle(tableTopRect, corner);
        let leftLeg = Shape.Rectangle(leftLegRect);
        let rightLeg = Shape.Rectangle(rightLegRect);
        setDefaultStyle(tableTop, leftLeg, rightLeg);
        switch (appearance.color) {
            case "white":
                tableTop.fillColor = "white";
                leftLeg.fillColor = "white";
                rightLeg.fillColor = "white";
                break;
            case "brown":
            case "fireproof":
                let gradient = new Gradient([
                    ["#ce9158", 0.2],
                    ["#ad7847", 0.21],
                    ["#704e2f", 1.0]
                ]);
                if (appearance.color == "brown") {
                    tableTop.fillColor = new Color(gradient, tableTopRect.topCenter, tableTopRect.bottomCenter);
                }
                else { // Fireproof
                    tableTop.withGradientFill("down", [["#665e57", 0.1], ["#312f2d", 0.3]]);
                }
                leftLeg.fillColor = new Color(gradient, leftLegRect.leftCenter, leftLegRect.rightCenter);
                rightLeg.fillColor = new Color(gradient, rightLegRect.leftCenter, rightLegRect.rightCenter);
        }
        var graphic = new Group();
        var legs = new Group();
        var hitShapes = [tableTopRect];
        if (appearance.legs == "left") {
            legs.addChild(leftLeg);
            hitShapes.push(leftLegRect);
            rightLeg.remove();
        }
        else if (appearance.legs == "right") {
            legs.addChild(rightLeg);
            hitShapes.push(rightLegRect);
            leftLeg.remove();
        }
        else if (appearance.legs == "both") {
            legs.addChild(leftLeg);
            legs.addChild(rightLeg);
            hitShapes.push(rightLegRect);
            hitShapes.push(leftLegRect);
        }
        else {
            rightLeg.remove();
            leftLeg.remove();
        }
        graphic.addChild(legs);
        graphic.addChild(tableTop);
        return {
            graphic: graphic,
            pivot: tableTopRect.center,
            hitShape: hitShapes.map(Shape.Rectangle),
            snapping: tableTop.topEdgeAsPlaceableSurface(),
        };
    }
}
Table.properties = {
    label: "Table",
    defaultAppearance: {
        height: "short",
        width: 700,
        thickness: 40,
        legs: "both",
        color: "brown",
        legOffset: 100,
    },
    appearanceSpecs: [
        {
            spec: "slider",
            key: "width",
            label: "Width",
            min: 400,
            max: 1500,
        },
        {
            spec: "slider", key: "thickness", label: "Thickness",
            min: 20, max: 40, step: 5
        },
        {
            spec: "radio",
            key: "color",
            label: "Colour",
            options: [
                { value: "white", label: "White" },
                { value: "brown", label: "Brown" },
                { value: "fireproof", label: "Fireproof" },
            ]
        },
        {
            spec: "radio",
            key: "legs",
            label: "Legs",
            options: [
                { value: "none", label: "No legs" },
                { value: "both", label: "Both legs" },
                { value: "left", label: "Left only" },
                { value: "right", label: "Right only" },
            ]
        },
        {
            spec: "radio",
            key: "height",
            label: "Legs display",
            options: [
                { value: "short", label: "Very short" },
                { value: "medium", label: "Short" },
                { value: "full", label: "Full height" },
            ],
            visible: a => a.legs != "none",
        },
        {
            spec: "slider",
            key: "legOffset",
            label: "Leg offset",
            min: 0,
            max: 100,
            visible: a => a.legs != "none",
        }
    ],
};
function getLegHeight(appearance) {
    switch (appearance.height) {
        case "short": return 75;
        case "medium":
            return 150;
        case "full": return 400;
    }
}
